export const getQuarterValue = (quarter: number) => {
    return ["I", "II", "III", "IV"][quarter - 1] || "";
};

export const getPositionValue = (position: number) => {
    return ["I", "II", "III"][position - 1] || "";
};
export const getQuarterValue = (quarter: number) => {
    return ["I", "II", "III", "IV"][quarter - 1] || "";
};

export const getPositionValue = (position: number) => {
    return ["I", "II", "III"][position - 1] || "";
};
